import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="align-items-center g-3">
          <Col md={7} className="text-center text-md-start">
            <p className="footer-title mb-1">SUPPoland.pl</p>
            <p className="footer-copy mb-0">
              SUPPoland &mdash; Rope access and work-at-height support for
              industrial, construction, and technical projects across Europe.
            </p>
          </Col>
          <Col md={5} className="text-center text-md-end">
            <a className="footer-link" href="mailto:info@suppoland.pl">
              info@suppoland.pl
            </a>
            <p className="footer-copy mb-0">&copy; 2026 All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;